<template lang="pug">
  div
    .form-group
      label.col-sm-3.control-label 文字コードと区切り文字
      .col-sm-9
        .collapse.form-control-static(:class="{in: !edit}")
          //- Cookieに保存されている設定を適用する
          | 文字コード: {{char_code.name}} / 区切り文字: {{char_sep.name}}
          |
          |
          a(href="#" title="設定を変更" @click.prevent="edit = true")
            i.fa.fa-edit.fa-lg

        .collapse(:class="{in: edit}")
          .form-group
            label.col-sm-2.control-label 文字コード
            .col-sm-8
              select.form-control(name="char_code" v-model="char_code.value")
                //- Cookieに保存されている設定を適用する
                option(value='0') シフトJIS(日本語、英数字のみ入力可能)
                option(value='1') BOMなしUTF8(日本語、英数字以外も入力可能)
                option(value='2') BOM付きUTF8(日本語、英数字以外も入力可能)
          .form-group
            label.col-sm-2.control-label 区切り文字
            .col-sm-8
              .radio.radio-rich
                //- Cookieに保存されている設定を適用する
                label
                  input(type="radio" name="char_sep" v-model="char_sep.value" value="0")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | カンマ
                |
                |
                label
                  input(type="radio" name="char_sep" v-model="char_sep.value" value="1")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | タブ
</template>

<script>
export default {
  name: 'ExportSettings',
  data: function () {
    return {
      char_code: {value: '0', name: 'シフトJIS'}, // 文字コード（初期値：Cookieに保存されている設定 or デフォルト）
      char_sep: {value: '0', name: 'カンマ'}, // 区切り文字（初期値：Cookieに保存されている設定 or デフォルト）
      edit: false // エクスポート設定の編集モードON/OFF
    }
  },
  created: function () {
    // 文字コードと区切り文字の設定
    // Cookieに保存されている設定を取得する
    let cookieArray = {
      char_code: this.getCookie('char_code'),
      char_sep: this.getCookie('char_sep')
    }

    // 文字コードと区切り文字がcookieに保存されている場合、設定を反映する
    // 保存されていない場合、デフォルト値を使う
    if (cookieArray['char_code'] && cookieArray['char_sep']) {
      // 取得した値を文字コードと区切り文字に設定する
      this.char_code.value = cookieArray['char_code']
      this.char_sep.value = cookieArray['char_sep']

      // 値に応じた文字列を設定する
      // 文字コード
      if (this.char_code.value === '0') {
        this.char_code.name = 'シフトJIS'
      }
      else if (this.char_code.value === '1') {
        this.char_code.name = 'BOMなしUTF8'
      }
      else if (this.char_code.value === '2') {
        this.char_code.name = 'BOM付きUTF8'
      }

      // 区切り文字
      if (this.char_sep.value === '0') {
        this.char_sep.name = 'カンマ'
      }
      else if (this.char_sep.value === '1') {
        this.char_sep.name = 'タブ'
      }
    }
  },
  methods: {
    // エクスポート・インポートが実行された場合に親から呼ばれる
    // 文字コードと区切り文字をCookieに保存する
    saveCookie: function () {
      this.setCookie('char_code', this.char_code.value)
      this.setCookie('char_sep', this.char_sep.value)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/ExportSettings.vue